var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12C3.92893 12 2.25 10.3211 2.25 8.25C2.25 6.41365 3.56994 4.88559 5.31282 4.56282C5.63559 2.81994 7.16365 1.5 9 1.5C10.8363 1.5 12.3644 2.81994 12.6872 4.56282C14.4301 4.88559 15.75 6.41365 15.75 8.25C15.75 10.3211 14.0711 12 12 12M6.75 14.25L9 16.5M9 16.5L11.25 14.25M9 16.5V7.5",
    stroke: "#706F6F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg9);
export default __webpack_public_path__ + "static/media/svg9.8bca6e6677ee90eb32dacbdb18407970.svg";
export { ForwardRef as ReactComponent };